import { render, staticRenderFns } from "./user_center_order.vue?vue&type=template&id=975bf10a&scoped=true"
import script from "./user_center_order.vue?vue&type=script&lang=js"
export * from "./user_center_order.vue?vue&type=script&lang=js"
import style0 from "./user_center_order.css?vue&type=style&index=0&id=975bf10a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975bf10a",
  null
  
)

export default component.exports